import {
  format,
  isSameDay,
  isSameYear,
  isYesterday,
  isToday,
  parseISO,
} from 'date-fns';
import _ from 'lodash';
import { leadingZero } from '@/utils/time';

const colors = [
  '#FFB900',
  '#D83B01',
  '#B50E0E',
  '#E81123',
  '#B4009E',
  '#5C2D91',
  '#0078D7',
  '#00B4FF',
  '#008272',
  '#107C10',
];

function prettyFormatDate(dateTime) {
  const date = parseISO(dateTime);
  if (isSameYear(date, new Date())) {
    return format(date, 'd MMMM');
  }
  return format(date, 'd MMMM yyyy');
}

function parseToTime(dateTime, millisec = false) {
  const output = millisec ? 'HH:mm:ss.SSS' : 'HH:mm:ss';
  if (typeof dateTime === 'string') {
    const time = parseISO(dateTime);
    return format(time, output);
  }
  return format(dateTime, output);
}

function parseDate(dateTime) {
  const date = parseISO(dateTime);
  if (isYesterday(date)) {
    return 'Yesterday';
  }
  if (isToday(date)) {
    return 'Today';
  }
  return prettyFormatDate(dateTime);
}

function prettyFormatPeriod(startedAt, endedAt) {
  const start = parseISO(startedAt);
  const end = parseISO(endedAt);
  if (isSameDay(start, end)) {
    return `${parseDate(startedAt)}, ${parseToTime(startedAt)} - ${parseToTime(endedAt)}`;
  }
  return `${prettyFormatDate(startedAt)} ${parseToTime(startedAt)} - ${prettyFormatDate(endedAt)} ${parseToTime(endedAt)}`;
}

function prettyFormatPeriodShort(startedAt, endedAt) {
  const start = parseISO(startedAt);
  const end = parseISO(endedAt);
  if (isSameDay(start, end)) {
    return `${format(start, 'dd/MM/yy')}, ${parseToTime(startedAt)} - ${parseToTime(endedAt)}`;
  }
  return `${format(start, 'dd/MM/yy')} ${parseToTime(startedAt)} - ${format(end, 'dd/MM/yy')} ${parseToTime(endedAt)}`;
}

function getDateTime(dateTime) {
  const date = parseISO(dateTime);
  if (isSameYear(date, new Date())) {
    return format(date, 'd MMM, HH:mm:ss');
  }
  return format(date, 'HH:mm:ss, d MMM yyyy');
}

function getDate(dateTime) {
  const date = parseISO(dateTime);
  if (isSameYear(date, new Date())) {
    return format(date, 'd MMM');
  }
  return format(date, 'd MMM yyyy');
}

function parseDuration(seconds) {
  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor(seconds / 60);
  const leftSeconds = Math.floor(seconds % 60);

  while (minutes >= 60) {
    minutes -= 60;
  }
  minutes = leadingZero(minutes);

  if (hours) {
    hours = leadingZero(hours);
    return `${hours}:${minutes}:${leftSeconds}`;
  }
  return `${minutes}:${leftSeconds}`;
}

function colorGeneratorFromString(textString) {
  const sum = _.sumBy(textString, item => item.charCodeAt(0));
  return colors[sum % colors.length];
}

export {
  parseToTime,
  prettyFormatDate,
  prettyFormatPeriod,
  prettyFormatPeriodShort,
  getDateTime,
  getDate,
  parseDuration,
  colorGeneratorFromString,
};
